export const SET_TREE_FIELD = 'SET_TREE_FIELD';

export function setTreeField(key, value) {
    return { type: SET_TREE_FIELD, key, value };
}
